import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import Label from './Label';
import Patch from '../icons/Patch';
import PatchedText from './PatchedText';
import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/image.scss';

const propTypes = {
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    imageUrl: PropTypes.string,
    nativeSize: PropTypes.bool,
    credits: AppPropTypes.text,
    format: PropTypes.string,
    withPlasters: PropTypes.bool,
    withPatch: PropTypes.bool,
    withRatio: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    src: null,
    width: null,
    height: null,
    imageUrl: null,
    nativeSize: false,
    credits: null,
    format: null,
    withPlasters: true,
    withPatch: false,
    withRatio: true,
    className: null,
};

const Image = ({
    src,
    width,
    height,
    imageUrl,
    nativeSize,
    credits,
    format,
    withPlasters,
    withPatch,
    withRatio,
    className,
}) => {
    if (src === null) {
        return null;
    }

    let blockHeight = 'auto';
    let ratio = null;
    if (width && height && !withPatch && withRatio && !nativeSize) {
        blockHeight = 0;
        ratio = (height / width) * 100;
    }

    const image = src ? (
        <img
            src={src}
            className={classNames([styles.image])}
            alt={credits}
            style={{ maxWidth: height > width && withPatch ? '55%' : '100%' }}
        />
    ) : null;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withLink]: imageUrl !== null,
                    [styles.withPatch]: withPatch,
                    [styles.nativeSize]: nativeSize,
                    [styles[format]]: format !== null,
                    [className]: className !== null,
                },
            ])}
            style={{ paddingBottom: `${ratio}%`, height: blockHeight }}
        >
            {imageUrl ? (
                <a
                    href={imageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.imageUrl}
                >
                    {image}
                </a>
            ) : (
                image
            )}
            {withPlasters && !nativeSize ? (
                <div className={styles.plasters}>
                    <div className={classNames([styles.plaster, styles.vertical])} />
                    <div className={classNames([styles.plaster, styles.horizontal])} />
                    <div className={classNames([styles.plaster, styles.vertical])} />
                </div>
            ) : null}
            {withPatch ? <Patch className={styles.patch} /> : null}
            {credits ? (
                <PatchedText
                    label={`© ${credits}`}
                    className={styles.credits}
                    backgroundClassName={styles.creditsBackground}
                />
            ) : null}
        </div>
    );
};

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

export default Image;

// {credits ? (
//     <div className={styles.credits}>
//
//     </div>
// ) : null}
